import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { buildMenuLinks } from "../../helpers";

class MenuLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [],
    };
    this._handleLinkClick = this._handleLinkClick.bind(this);
  }
  componentDidMount() {
    //Error fix: Prevent carousel from scrolling back to beginning
    var menucloser = document.getElementById("closemenu");
    menucloser.addEventListener("click", function (event) {
      event.preventDefault();
    });

    axios
      .get(
        `https://cdn.contentful.com/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE_ID}/environments/master/entries/367e1uw0JM2bWAmz93nMs9?access_token=${process.env.REACT_APP_CONTENTFUL_API}`
      )
      .then(async (response) => {
        const links = await buildMenuLinks(response);
        /**
          * Contentful does not have child links implemented
          
          var navItems = response.data.items;
          var currentLinks = this.state.links;
  
          for (var key in navItems) {
            var childLinks = [];
            for (var child_key in navItems[key].child_items) {
              childLinks.push({
                id: navItems[key].child_items[child_key].ID,
                text: navItems[key].child_items[child_key].title,
                textLower: navItems[key].child_items[
                  child_key
                ].title.toLowerCase(),
                link: navItems[key].child_items[child_key].url,
                isChild: true,
              });
            }
            currentLinks.push({
              id: navItems[key].ID,
              text: navItems[key].title,
              textLower: navItems[key].title.toLowerCase(),
              link: navItems[key].url,
              children: childLinks,
              isChild: false,
            });
          }
          */
        this.setState({
          links,
        });
      });
  }

  // childrenLinks(link, headerStyles) {
  //   var children = link.children;
  //   if (children.length === 0) {
  //     return;
  //   } else {
  //     let childList = [];
  //     let childrenLinks = [];
  //     //Create children
  //     for (let j = 0; j < children.length; j++) {
  //       childrenLinks.push(
  //         <li key={children[j].id} ref={j + 1}>
  //           <Link
  //             data-key={children[j].id}
  //             style={headerStyles}
  //             onClick={this._handleLinkClick}
  //             onMouseEnter={this._handleLinkEnter}
  //             onMouseLeave={this._handleLinkLeave}
  //             to={"/" + link.textLower + "/" + children[j].textLower}
  //           >
  //             {children[j].text}
  //           </Link>
  //         </li>
  //       );
  //     }
  //     //Create the parent and add the children
  //     childList.push(
  //       <ul className='menu-level-2' key={link.id}>
  //         {childrenLinks}
  //       </ul>
  //     );
  //     return childList;
  //   }
  // }

  _handleLinkClick(e) {
    var indicator = document.getElementById("menu-indicator");
    indicator.style.width = "0px";
    var that = this;
    e.persist();
    setTimeout(function () {
      var menuButton = document.getElementById("menuButton");

      menuButton.style.opacity = that.props.isClosed ? 0 : 1;
      that.props.setShadowClass(that.props.isClosed ? "menu-box-shadow" : "");
      that.props.setCloseState(!that.props.isClosed);
    }, 500);
  }

  _handleLinkEnter(e) {
    var indicator = document.getElementById("menu-indicator");

    var top = e.target.getBoundingClientRect().top;
    var bottom = e.target.getBoundingClientRect().bottom;
    var midpoint = (bottom - top) / 2;

    var menuLeft = document.getElementById("menu").getBoundingClientRect().left;
    var left = e.target.getBoundingClientRect().left;
    var width = left - menuLeft - 20;

    indicator.style.top =
      e.target.getBoundingClientRect().top + midpoint + "px";
    indicator.style.width = width + "px";
  }

  _handleLinkLeave(e) {
    var indicator = document.getElementById("menu-indicator");
    indicator.style.width = "0px";
  }
  render() {
    //var toggleClass = this.props.isTransparent ? "close-menu-white" : "close-menu-black";
    var toggleClass = "close-menu-black";
    var indicatorStyles = {
      background: "black",
    };

    var menuStyles = {
      borderLeft: this.props.isTransparent ? "none" : "none",
      backgroundColor: this.props.isTransparent
        ? "rgba(255, 255, 255, 0.8)"
        : "rgba(255, 255, 255, 0.9)",
    };

    var linkColor = {
      color: "black",
    };

    let links = this.state.links.map((link, i) =>
      link.text === "Instagram" ? (
        <li key={link.id} ref={i + 1}>
          <a
            rel='noopener noreferrer'
            target='_blank'
            data-key={link.id}
            className='menu-link-level-1'
            style={linkColor}
            onClick={this._handleLinkClick}
            onMouseEnter={this._handleLinkEnter}
            onMouseLeave={this._handleLinkLeave}
            href={link.link}
          >
            {link.text}
          </a>
          {/* {this.childrenLinks(link, linkColor)} */}
        </li>
      ) : (
        <li key={link.id} ref={i + 1}>
          <Link
            data-key={link.id}
            className='menu-link-level-1'
            style={linkColor}
            onClick={this._handleLinkClick}
            onMouseEnter={this._handleLinkEnter}
            onMouseLeave={this._handleLinkLeave}
            to={"/" + link.textLower}
          >
            {link.text}
          </Link>
          {/* {this.childrenLinks(link, linkColor)} */}
        </li>
      )
    );

    return (
      <div
        className={this.props.menuStatus + " " + this.props.boxShadowClass}
        id='menu'
        style={menuStyles}
      >
        <span style={indicatorStyles} id='menu-indicator'></span>
        <button
          className={toggleClass}
          onClick={this.props.menuToggle}
          href='#'
          id='closemenu'
        >
          &nbsp;
        </button>
        <ul className='menu-level-1'>{links}</ul>
      </div>
    );
  }
}

export default MenuLinks;
